var i = Object.defineProperty, p = Object.defineProperties;
var c = Object.getOwnPropertyDescriptors;
var m = Object.getOwnPropertySymbols;
var s = Object.prototype.hasOwnProperty, g = Object.prototype.propertyIsEnumerable;
var o = (r, e, a) => e in r ? i(r, e, { enumerable: !0, configurable: !0, writable: !0, value: a }) : r[e] = a, t = (r, e) => {
  for (var a in e || (e = {}))
    s.call(e, a) && o(r, a, e[a]);
  if (m)
    for (var a of m(e))
      g.call(e, a) && o(r, a, e[a]);
  return r;
}, f = (r, e) => p(r, c(e));
import n, { forwardRef as I } from "react";
import d from "../lib/IconBase.mjs";
import l from "../defs/ImageSquare.mjs";
const q = I((r, e) => /* @__PURE__ */ n.createElement(d, f(t({ ref: e }, r), { weights: l })));
q.displayName = "ImageSquare";
export {
  q as ImageSquare
};
